import { Controller } from "@hotwired/stimulus"
import { copyTextToClipboard } from "../lib/clipboard"
import { setHidden, isHidden } from "../lib/display_toggle"

// Connects to data-controller="demand-forecast"
// Dropdown filters trigger server-side Turbo visits.
// Search input filters visible table rows client-side.
export default class extends Controller {
  static targets = ["leadType", "quality", "searchInput", "row"]

  applyFilters(event) {
    event?.preventDefault()
    const params = new URLSearchParams()

    if (this.hasLeadTypeTarget && this.leadTypeTarget.value) {
      params.set("lead_type", this.leadTypeTarget.value)
    }
    if (this.hasQualityTarget && this.qualityTarget.value) {
      params.set("quality", this.qualityTarget.value)
    }

    const query = params.toString()
    const url = query ? `/admin/demand_forecasts?${query}` : "/admin/demand_forecasts"
    Turbo.visit(url)
  }

  clearFilters(event) {
    event?.preventDefault()

    if (this.hasLeadTypeTarget) this.leadTypeTarget.value = ""
    if (this.hasQualityTarget) this.qualityTarget.value = ""
    if (this.hasSearchInputTarget) this.searchInputTarget.value = ""

    Turbo.visit("/admin/demand_forecasts")
  }

  filterRows() {
    const query = this.hasSearchInputTarget
      ? this.searchInputTarget.value.trim().toLowerCase()
      : ""

    this.rowTargets.forEach(row => {
      const matches = !query || row.textContent.toLowerCase().includes(query)
      setHidden(row, !matches)
    })
  }

  copyStates(event) {
    const button = event.currentTarget
    const tabPane = button.closest(".tab-pane") || this.element

    const states = new Set()
    tabPane.querySelectorAll('tr[data-has-need="true"]').forEach(row => {
      if (!isHidden(row) && row.dataset.stateName) {
        states.add(row.dataset.stateName)
      }
    })

    const sorted = [...states].sort()

    if (sorted.length === 0) {
      this.#showButtonFeedback(button, "No states to copy")
      return
    }

    copyTextToClipboard(sorted.join(", "))
      .then((copied) => this.#showButtonFeedback(button, copied ? "Copied!" : "Copy failed"))
  }

  #showButtonFeedback(button, message) {
    const originalHTML = button.innerHTML
    button.textContent = message
    button.disabled = true
    setTimeout(() => {
      button.innerHTML = originalHTML
      button.disabled = false
    }, 2000)
  }
}
